/**
 * Browser stub for bittorrent-protocol/mse.js
 *
 * MSE/PE (Message Stream Encryption / Protocol Encryption) is a TCP-level
 * protocol used by desktop BitTorrent clients to obfuscate traffic.
 *
 * Browsers ONLY use WebRTC for BitTorrent — TCP connections are impossible
 * from browser JavaScript. Therefore MSE/PE has zero relevance in a browser
 * bundle. bittorrent-protocol itself declares this intent:
 *
 *   "browser": { "./mse.js": false }
 *
 * Vite/Rollup replace browser:false with an empty module, but Rollup's strict
 * ESM enforcement then throws "nativeRC4 is not exported" because bittorrent-
 * protocol/index.js uses named imports ({ MessageStreamEncryptor, nativeRC4 }).
 *
 * This stub exports the expected names as browser-safe no-ops, satisfying
 * Rollup's static analysis while maintaining the correct runtime semantics
 * (nativeRC4 = false → JS fallback path; MessageStreamEncryptor → unused).
 */

// nativeRC4 = false → bittorrent-protocol uses its pure-JS RC4 fallback.
// In browser WebRTC mode, the Wire never enables encryption anyway.
export const nativeRC4 = false;

// No-op stub — MessageStreamEncryptor is instantiated only when the Wire
// negotiates protocol encryption, which never occurs over WebRTC.
export class MessageStreamEncryptor {
  encrypt() {}
  decrypt() {}
}
